import React from "react";
import { useNavigate } from "react-router-dom";
import FormatPrice from "../../../../components/FormatPrice";
import { useDispatch } from "react-redux";
import { setSelectedProduct } from "../../../../api/reducers/selectedProductReducer";
import RetailRichTextDescription from "../../RetailRichTextDescription";
import { academyLogger } from "utils/logger";

const ProductsList = ({ products, loggedIn }) => {
    const productsPerPage = 15;
    const currentProducts = products.slice(0, productsPerPage);

    return (
        <div id="product-list" className="p-4">
            {/* Product Grid */}
            <div id="product-grid" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-10">
                {currentProducts.length > 0 ? (
                    currentProducts.map((item) => (
                        <ProductItem key={item._id} productItem={item} loggedIn={loggedIn} />
                    ))
                ) : (
                    <div className="col-span-full">
                        <div className="animate-pulse bg-gray-200 h-64 rounded-md"></div>
                    </div>
                )}
            </div>
        </div>
    );

};

const ProductItem = ({ productItem }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleProductClick = (product) => {
        academyLogger.info("Selected Product:", product);
        //set the selected prodct to redux state
        dispatch(setSelectedProduct(product));
        academyLogger.info("Product dispatched to Redux state");
        navigate("/at/product-info");
    };

    const currentImage = productItem.imageContents?.[0]?.displayLink || productItem.imageURL || "";

    return (
        <div
            id="product-item"
            className="flex flex-col rounded-lg border border-gray-200 overflow-hidden bg-white shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer w-full max-w-xl"
            onClick={() => handleProductClick(productItem)}
        >
            {/* Product Image */}
            <div className="w-full relative overflow-hidden bg-gray-50" style={{ aspectRatio: "3/4" }}>
                <img
                    loading="lazy"
                    id="product-image"
                    src={currentImage}
                    alt={productItem.name}
                    className="w-full h-full object-cover object-top"
                />
            </div>

            {/* Product Details */}
            <div id="product-details" className="p-6 flex flex-col justify-between flex-1"> {/* Increased padding */}
                <div id="product-info" className="flex-1">
                    <h2 className="text-xl font-semibold text-gray-700 hover:text-[#f4a649] transition-colors duration-200">
                        {productItem.name}
                    </h2>
                    <p id="product-price" className="mt-2 text-2xl font-bold text-[#f4a649]"> {/* Increased font size */}
                        {productItem.price && (
                            <FormatPrice
                                code={productItem.price.currency || "USD"}
                                price={productItem.price.priceAmt}
                            />
                        )}
                    </p>
                    <RetailRichTextDescription content={productItem.description} className="mt-2" />
                </div>

                {/* Add to Cart Button */}
                <button
                    className="mt-2 py-2 px-4 rounded-full w-full text-white bg-[#f4a649] hover:bg-white hover:text-[#f4a649] border border-[#f4a649] transition duration-300 text-sm md:text-base"
                    onClick={() => handleProductClick(productItem)}
                >
                    <span className="ml-2">
                        View Product
                    </span>
                </button>
            </div>

        </div>
    );


};

export default ProductsList;
